import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import { IServiceInterval } from '../../../../../model/IServicePlan';
import servicePlanItemDetailsStyles from './servicePlanItemDetailsStyles';
import ServiceInterval from '../serviceInterval/ServiceInterval';
import Price from '../../../../../../common/components/presentation/Price';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import Translation from '../../../../../../common/components/translation/Translation';

export interface IServicePlanItemDetailsProps {
  serviceIntervals: IServiceInterval[];
  totalBasePrice: number;
}

const ServicePlanItemDetails: FunctionComponent<IServicePlanItemDetailsProps> = ({
  serviceIntervals,
  totalBasePrice,
}) => {
  const styles = servicePlanItemDetailsStyles();
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();

  return (
    <Box mt={3}>
      <Box display="flex" justifyContent="space-between">
        <Typography className={styles.headerItem}>
          <Translation id="spc.customise.serviceSection.scheduledServiceInterval" />
        </Typography>
        <Typography className={styles.headerItem}>
          <Translation id="spc.customise.serviceSection.const" />
        </Typography>
      </Box>
      {serviceIntervals?.map(serviceInterval => (
        <ServiceInterval key={serviceInterval.description} serviceInterval={serviceInterval} />
      ))}
      <Box className={styles.totalContainer}>
        <Typography className={styles.totalLabel}>
          <Translation id="spc.customise.serviceSection.total" />
        </Typography>
        <Typography className={styles.headerItem}>
          <Price
            data-test="customise:servicePlanIntervalTotal"
            className={styles.totalValue}
            price={totalBasePrice}
            currency={priceDisplay.primaryOptions.currency}
            decimals={priceDisplay.primaryOptions.decimalScale}
          />
        </Typography>
      </Box>
    </Box>
  );
};

export default ServicePlanItemDetails;
